export default __webpack_public_path__ + "static/media/tyre.c4d99a6c.png";